import { useQuery, useMutation, useQueryClient } from 'react-query'
import { api } from '../../../../services/api'

export const useRoletaService = () => {
  const queryClient = useQueryClient()

  const fetchPremios = async () => {
    const response = await api.get('/site/v2/fluxo-roleta/listar-premios')
    return response.data
  }

  const escolherProximoPremioMutation = useMutation((id_premio) => api.put('/site/v2/fluxo-roleta/escolher-proximo-premio', { id_premio }), {
    onSuccess: () => {
      queryClient.invalidateQueries('premios')
    },
  })

  const atribuirPremioClienteMutation = useMutation(
    ({ codigo_cliente, id_premio }) => api.put('/site/v2/fluxo-roleta/escolher-proximo-premio', { codigo_cliente, id_premio }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('premios')
      },
    }
  )

  const chamarClienteWhatsappMutation = useMutation(
    (codigo_cliente) => api.get(`/site/v2/fluxo-roleta/chamar-cliente-whatsapp?codigo_cliente=${codigo_cliente}`),
    {
      onSuccess: () => {
        // Invalidar a query após chamar cliente no WhatsApp para atualizar dados
        queryClient.invalidateQueries('premios')
      },
    }
  )

  const confirmarBrindeEntregueMutation = useMutation(
    (codigo_cliente) => api.get(`/site/v2/fluxo-roleta/marcar-premio-entregue?codigo_cliente=${codigo_cliente}`),
    {
      onSuccess: () => {
        // Invalidar a query após confirmar entrega do brinde para atualizar dados
        queryClient.invalidateQueries('premios')
      },
    }
  )

  const { data, isLoading, error, isRefetching } = useQuery('premios', fetchPremios, {
    refetchOnWindowFocus: true,
    // Revalidar automaticamente a cada 60 segundos (1 minuto)
    refetchInterval: 60000,
    // Continuar refetch mesmo quando a janela não está em foco
    refetchIntervalInBackground: true,
  })

  return {
    premios: data?.premios || [],
    clientes: data?.dados_usuarios || [],
    sumarioPremios: data?.sumario || [],
    isLoading,
    error,
    isRefetching,

    escolherProximoPremio: (id) => {
      return new Promise((resolve, reject) => {
        escolherProximoPremioMutation.mutate(id, {
          onSuccess: (data) => resolve(data),
          onError: (error) => reject(error),
        })
      })
    },

    atribuirPremioCliente: (codigo_cliente, id_premio) => {
      return new Promise((resolve, reject) => {
        atribuirPremioClienteMutation.mutate(
          { codigo_cliente, id_premio },
          {
            onSuccess: (data) => resolve(data),
            onError: (error) => reject(error),
          }
        )
      })
    },

    chamarClienteWhatsapp: (codigo_cliente) => {
      return new Promise((resolve, reject) => {
        chamarClienteWhatsappMutation.mutate(codigo_cliente, {
          onSuccess: (data) => resolve(data),
          onError: (error) => reject(error),
        })
      })
    },

    confirmarBrindeEntregue: (codigo_cliente) => {
      return new Promise((resolve, reject) => {
        confirmarBrindeEntregueMutation.mutate(codigo_cliente, {
          onSuccess: (data) => resolve(data),
          onError: (error) => reject(error),
        })
      })
    },

    isEscolhendoPremio: escolherProximoPremioMutation.isLoading,
    isAtribuindoPremio: atribuirPremioClienteMutation.isLoading,
    isChamandoCliente: chamarClienteWhatsappMutation.isLoading,
    isConfirmandoBrindeEntregue: confirmarBrindeEntregueMutation.isLoading,
  }
}
